import { getSessionItem, removeSessionItem, setSessionItem } from './storageUtils';

const JOIN_DATA_KEY = 'join_data';
const JOIN_STATE_KEY = 'join_state';
const IDENTIFY_DATA_KEY = 'identify_data';

export const getJoinData = () => getSessionItem(JOIN_DATA_KEY);
export const setJoinData = (data) => setSessionItem(JOIN_DATA_KEY, data);
export const putJoinData = (key, data) => {
	const joinData = getJoinData();
	const newJoinData = { ...joinData, [key]: data };
	setSessionItem(JOIN_DATA_KEY, newJoinData);
};
export const outJoinData = (key) => {
	const joinData = getJoinData();

	if (joinData && joinData[key]) {
		delete joinData[key];
	}

	setSessionItem(JOIN_DATA_KEY, joinData);
};
export const deleteJoinData = () => {
	removeSessionItem(JOIN_DATA_KEY);
};
export const clearJoinData = () => {
	removeSessionItem(JOIN_DATA_KEY);
	removeSessionItem(JOIN_STATE_KEY);
	removeSessionItem(IDENTIFY_DATA_KEY);
};
export const popJoinData = () => {
	const joinData = getJoinData();
	deleteJoinData();

	return joinData;
};
